// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"VnCVQauh","backBtn":"__5bx9qlob","title":"__6lEk56w9","actions":"xpgYWl8o"};